import { Navigate } from 'react-router'

export const PrivateCheckout = ({ children }) => {
  const cartItems = localStorage.getItem('cartItems')
  const cartItemsArray = JSON.parse(cartItems)
  if (cartItemsArray.length !== 0) {
    return <>{children}</>
  } else {
    return <Navigate to="/cart" />
  }
}
